import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { WorkerDashboardService } from './worker-dashboard.service';
import { RouterLink } from '@angular/router';
import { CardBarComponent } from '../../../../components/card-bar/card-bar.component';
import { AuthorizationService } from '@nimmsta/ng-commons-lib/auth';
import { LoadingIndicatorComponent } from '@nimmsta/ng-commons-lib/loading-indicator';
import { UserRole } from '@nimmsta/ng-commons-lib/models';
import {
  DashboardComponentInterface,
  DashboardComponentSize,
} from '../../../../models/dashboard';
import { CardDataItem } from '../../../../models/cardDataItem';
import { STATUS_WIDGET_REFRESH_INTERVAL_MS } from '../status-widget-refresh.constants';

@Component({
  selector: 'app-worker-dashboard',
  templateUrl: './worker-dashboard.component.html',
  imports: [RouterLink, CardBarComponent, LoadingIndicatorComponent],
})
export class WorkerDashboardComponent
  implements OnInit, OnDestroy, DashboardComponentInterface
{
  private authorizationService = inject(AuthorizationService);
  private workerDashboardService = inject(WorkerDashboardService);
  @Input()
  configuration = {
    size: DashboardComponentSize.FULL,
    dataConnectionIds: [],
    title: 'Jobs',
    description: undefined,
  };

  readonly intervalTime = STATUS_WIDGET_REFRESH_INTERVAL_MS;

  protected workerData: CardDataItem[] = [new CardDataItem('Loading', 0)];

  protected isLoading = false;

  protected canNavigateToUsers = this.authorizationService.matches({
    anyRoles: [UserRole.ADMIN, UserRole.MANAGER],
    anyPermissions: ['worker.read', 'worker.write'],
  });

  private isFirstLoad = true;

  private interval?: ReturnType<typeof setInterval> = undefined;

  ngOnInit() {
    this.interval = setInterval(() => this.loadData(), this.intervalTime);
  }

  ngOnDestroy() {
    clearInterval(this.interval);
  }

  setConfiguration(configuration: unknown): void {
    this.configuration = {
      ...this.configuration,
      ...(configuration as object),
    };
  }

  loadData() {
    if (this.isFirstLoad) {
      this.isFirstLoad = false;
      this.isLoading = true;
    }
    this.workerDashboardService.getData().subscribe((data) => {
      this.workerData = data.map(
        (item) => new CardDataItem(item.status, item.count),
      );
      this.isLoading = false;
    });
  }
}
